import React from 'react';
import { Layout } from '../components/Layout';

export const Profile = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  return (
    <Layout title="👤 Profile" subtitle="Data diri Anda">
      <div className="tg-card">
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className="tg-avatar" style={{ width: '60px', height: '60px', fontSize: '30px' }}>👤</div>
          <div>
            <div style={{ fontSize: '18px', fontWeight: '600' }}>{user.full_name}</div>
            <div style={{ color: 'var(--tg-gray)' }}>{user.phone}</div>
            <div style={{ color: 'var(--tg-gray)' }}>{user.email}</div>
          </div>
        </div>
        <hr style={{ borderColor: 'rgba(255,255,255,0.05)', margin: '16px 0' }} />
        <div>Gender: {user.gender}</div>
        <div>Role: {user.role}</div>
        <div>Kode Referral: {user.referral_code}</div>
      </div>
    </Layout>
  );
};
